import { Injectable } from '@angular/core';

import { SirenCache, SirenResponse } from '@awp/http';
import { Store } from '@ngrx/store';
import { SirenResponseAction } from './state/actions';

@Injectable()
export class SirenCacheNgrx extends SirenCache {

  constructor(private store: Store<any>) {
    super();
  }

  setResponse(key: string, value: SirenResponse): void {
    if (!this._isRestoring) {
      this.store.dispatch(new SirenResponseAction( {id: key, response: value }));
    }
    super.setResponse(key, value);
  }

}